module.exports = __webpack_public_path__ + "static/media/mobile-app.4305511d.svg";